<!-- prettier-ignore -->

<button class="chat__button" type="submit" [disabled]="isInvalid()">
  <icon-send />
</button>
